import { HorizontalFlex } from '@eversports/react-components/primitives/Flex'
import TextField from '@eversports/react-components/primitives/TextField'
import React from 'react'
import styled from 'styled-components'

import { Localized } from '../../localization/react'

import PhoneNumberFieldCountryCallingCodes from './PhoneNumberFieldCountryCallingCodes'

const StyledHorizontalFlex = styled(HorizontalFlex).withConfig({
  shouldForwardProp: (prop) => !['horizontalSpacing'].includes(prop),
})`
  display: flex;
  gap: ${({ horizontalSpacing }) => (horizontalSpacing === 'dense' ? '8px' : '16px')};
`

const PhoneNumberField: React.FC<React.PropsWithChildren<unknown>> = () => (
  <StyledHorizontalFlex horizontalSpacing="dense">
    <div>
      <PhoneNumberFieldCountryCallingCodes />
    </div>
    <TextField type="phone" name="phoneNumber" label={<Localized id="phone-number" />} fullWidth />
  </StyledHorizontalFlex>
)

export default PhoneNumberField
